<ng-container *ngIf="isVisible">
    <div
        [id]="field.id"
        [matTooltip]="field.tooltip ? (field.tooltip | translate) : ''"
        [ngClass]="field.panelClass"
        (click)="onTextAction($event)"
    >
        {{ field.label | translateSmart }}
    </div>
</ng-container>
